import { FC } from "react";

import { HideUnlessEditModeButton } from "components/materials/HideUnlessEditModeButton";
import { PagesCard } from "components/materials/topic/activity/detail/PagesCard";
import { t } from "i18n/i18n";
import { Card } from "mds/components/Card";
import { useCapabilities } from "store/capability-hooks";
import { selectPagesByActivityId } from "store/selectors";
import { useListSelector } from "store/store-hooks";
import { PAGE_LIST_ITEM_FIELDS, usePageActions } from "utils/page";

export type AdditionalResourceListProps = {
  activityId: string;
};

/**
 * This component is for displaying a list of additional resources (Pages) related to a topic.
 * Note that there is exactly 1 addition resource activity per topic, and it cannot be archived or
 * renamed. There is no time estimate for an additional resource activity.
 */
export const AdditionalResourceList: FC<AdditionalResourceListProps> = ({ activityId }) => {
  const { canAuthorSection } = useCapabilities();
  const pages = useListSelector(
    (s) => selectPagesByActivityId(s, activityId),
    PAGE_LIST_ITEM_FIELDS,
  );

  const { createPage } = usePageActions();

  const createAndWaitForPage = () => createPage("activity_page", activityId);

  return (
    <div>
      <PagesCard
        activityId={activityId}
        canManagePages={canAuthorSection}
        header={t("glossary.additional_resources")}
        pages={pages}
        addTopicParam
      />

      {canAuthorSection && pages.length === 0 && (
        <Card className="mb-3 mt-2" small>
          <div className="-ml-1">
            <HideUnlessEditModeButton reference="page" onClick={createAndWaitForPage} />
          </div>
        </Card>
      )}
    </div>
  );
};
